import adminApiFetch from './apiService';

export const integrationService = {
  // List all integrations
  getList: async () => {
    const response = await adminApiFetch('integrations');
    return response.json();
  },

  // Get paginated records with filters
  getRecords: async (params) => {
    const response = await adminApiFetch('integrations/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // Get single integration detail
  get: async (id) => {
    const response = await adminApiFetch(`integrations/${id}`);
    return response.json();
  },

  // Create new integration
  create: async (data) => {
    const response = await adminApiFetch('integrations', {
      method: 'POST',
      body: JSON.stringify({ integration: data }),
    });
    return response.json();
  },

  // Update integration
  update: async (id, data) => {
    const response = await adminApiFetch(`integrations/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ integration: data }),
    });
    return response.json();
  },

  // Delete integration
  delete: async (id) => {
    const response = await adminApiFetch(`integrations/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },

  // Toggle active status
  toggleActive: async (id) => {
    const response = await adminApiFetch(`integrations/${id}/toggle_active`, {
      method: 'POST',
    });
    return response.json();
  },

  // Regenerate access token
  regenerateToken: async (id) => {
    const response = await adminApiFetch(`integrations/${id}/regenerate_token`, {
      method: 'POST',
    });
    return response.json();
  },

  // Get available scopes
  getAvailableScopes: async () => {
    const response = await adminApiFetch('integrations/available_scopes');
    return response.json();
  },
};
